export default class Tag {
    id = null;
    organizationId = null;
    name = null;
    color = null;
    group = null;
    description = null;
    icon = null;
    isActive = true;
    createdOn = null;
    createdBy = null;
    updatedOn = null;
    updatedBy = null;
    eTag = null;

    constructor(tag) {
        this.id = tag.id;
        this.organizationId = tag.organizationId;
        this.name = tag.name;
        this.color = tag.color;
        this.group = tag.group;
        this.description = tag.description;
        this.icon = tag.icon;
        this.isActive = tag.isActive;
        this.createdOn = tag.createdOn;
        this.createdBy = tag.createdBy;
        this.updatedOn = tag.updatedOn;
        this.updatedBy = tag.updatedBy;
        this.eTag = tag.eTag;
    }
}
